// extracted by mini-css-extract-plugin
export default {"message--action":"OrderStatusBlock_message--action__2ZNLH"};